import { ChangeDetectorRef, Component, Inject, QueryList, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatButtonToggle } from '@angular/material/button-toggle';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MapLayersSettingsOption } from '../../services';
import { SelectionModel } from '@angular/cdk/collections';
import Env from '@ridango/core/env';
import { ApplicationFacade } from '@ridango/components';

type MapSettingsDialogComponentData = {
    layers: MapLayersSettingsOption[];
    overlays: MapLayersSettingsOption[];
    selectedLayer: MapLayersSettingsOption;
    hiddenOverlays: string[];
};

@Component({
    selector: 'rwidget-map-settings-dialog',
    templateUrl: './map-settings-dialog.component.html',
    styleUrls: ['./map-settings-dialog.component.scss']
})
export class MapSettingsDialogComponent {
    @ViewChildren(MatButtonToggle) toggles: QueryList<MatButtonToggle>;

    public saveButtonColor: string[];

    public selectedLayer: FormControl = new FormControl(this.data.selectedLayer);

    public hiddenOverlays = new SelectionModel<string>(true, this.data.hiddenOverlays);
    public filteredOverlays: MapLayersSettingsOption[];
    isContrast$ = this.applicationFacade.highContrast$;

    constructor(
        public dialogRef: MatDialogRef<MapSettingsDialogComponent>,
        private cdr: ChangeDetectorRef,
        private applicationFacade: ApplicationFacade,
        @Inject('ENV') public env: Env,
        @Inject(MAT_DIALOG_DATA) public data: MapSettingsDialogComponentData
    ) {
        this.setSaveButtonColor();
        this.filterOverlays();
    }

    onSubmit(): void {
        const payload = {
            baseLayer: this.selectedLayer.value,
            hiddenOverlays: this.hiddenOverlays.selected
        };
        this.dialogRef.close(payload);
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    onToggle(option: string): void {
        this.hiddenOverlays.toggle(option);
    }

    isChecked(option: string): boolean {
        return !this.hiddenOverlays.isSelected(option);
    }

    setSaveButtonColor() {
        switch (this.env.APP_NAME) {
            case 'gotland':
                this.saveButtonColor = ['bg-[var(--color-secondary)]', 'text-primary'];
                break;
            case 'vastmanland-app':
            case 'orebro':
                this.saveButtonColor = ['bg-[var(--btn-primary-color)]', 'text-black'];
                break;
            case 'panevezys':
                this.saveButtonColor = ['bg-[var(--btn-primary-color)]', 'text-white'];
                break;
            default:
                this.saveButtonColor = ['text-white', 'bg-secondary'];
        }
    }

    private filterOverlays(): void {
        this.filteredOverlays = this.data.overlays;

        if (this.env.EXPLORE?.HIDE_SAVED_LOCATIONS_TOGGLE) {
            this.filteredOverlays = this.data.overlays.filter((overlay) => overlay.name !== 'favorite-locations');
        }
    }
}
